var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_97)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7217 2C7.19868 2 2.72168 6.477 2.72168 12C2.72168 17.523 7.19868 22 12.7217 22C18.2447 22 22.7217 17.523 22.7217 12C22.7217 6.477 18.2447 2 12.7217 2ZM9.22168 9.5C9.22168 9.04037 9.31221 8.58525 9.4881 8.16061C9.66399 7.73597 9.9218 7.35013 10.2468 7.02513C10.5718 6.70012 10.9576 6.44231 11.3823 6.26642C11.8069 6.09053 12.2621 6 12.7217 6C13.1813 6 13.6364 6.09053 14.0611 6.26642C14.4857 6.44231 14.8715 6.70012 15.1966 7.02513C15.5216 7.35013 15.7794 7.73597 15.9553 8.16061C16.1311 8.58525 16.2217 9.04037 16.2217 9.5C16.2217 10.4283 15.8529 11.3185 15.1966 11.9749C14.5402 12.6313 13.6499 13 12.7217 13C11.7934 13 10.9032 12.6313 10.2468 11.9749C9.59043 11.3185 9.22168 10.4283 9.22168 9.5ZM18.9797 16.984C18.2311 17.9256 17.2795 18.686 16.1958 19.2082C15.1122 19.7305 13.9246 20.0011 12.7217 20C11.5188 20.0011 10.3311 19.7305 9.24751 19.2082C8.16388 18.686 7.21224 17.9256 6.46368 16.984C8.08468 15.821 10.2967 15 12.7217 15C15.1467 15 17.3587 15.821 18.9797 16.984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.72168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.25fd6548a6e34106fb8d43fd5d6a915e.svg";
export { ForwardRef as ReactComponent };